import { AppBar } from '@material-ui/core';
import { Events, Linked } from '@type-r/models';
import { useIO, useModel } from '@type-r/react';
import { Flex, PrimaryButton, Toolbar, PageTab, TransparentTabs, useLinkedLocation, Loading, Page, AddFilter, FiltersList, Tile, TileField, TilesList, PageContainer } from 'lqx-react';
import * as React from 'react';
import { globalStore, RelationshipFilters, RelationshipModel } from 'api';

export const RelationshipsLandingPage = () => {

    const filter = useModel(RelationshipFilters);
    const $category = useLinkedLocation(2, 'all'),
        { value: category } = $category;
    const isReady = useIO( async () => globalStore.relationships.hasPendingIO() );

    // Apply filter
    React.useMemo(() =>
        {
            if (isReady) {
                filter.initializeOptions(globalStore.relationships);
            }
        }, [isReady]);
    const filteredItems = React.useMemo(
        () => {
            return globalStore.relationships
                .filter( x => x.filter(filter))
                .slice(0, 50);
            },
        [ isReady, filter.customerName, filter.supplierName, filter.customerExternalId, filter.supplierExternalId ]
    );

    return (
        isReady ?
            <PageContainer
                header={<RelationshipPageTabs $category={ $category }/>
                }

            >
            <Page
            maxWidth={false}
            top={
                <AppBar position="static" color="transparent">
                    <Toolbar>
                        <AddFilter
                            filter={filter}
                            filterAllPlaceholder="Filter by..."
                        />
                        <Flex grow />
                    </Toolbar>
                        <FiltersList filter={filter} />
                </AppBar>
            }>

                <TilesList
                    expandedAppBar={true}
                    items={filteredItems}
                    itemSize={60}
                    renderer={RelationshipTile(false)}
                  />
            </Page>
            </PageContainer>
        :
        <Loading />
    );
};

const RelationshipTile = disable => ({ data, style, index }) => {
    const relationship: RelationshipModel = data.items[ index ]
    // $checked = data.selected.$includes( relationship );
    return (
        <Tile
            style={ style }
            color={!!!relationship.Customer || !!!relationship.Supplier ? 'red' : '#01C38D'}
            title={ relationship.title}
            onClick={() => Events.trigger( 'navigate', `/relationships/${relationship.id}`)}
            $checked={ true }
        >
            <TileField label='Customer External ID'>
                {relationship.Customer && relationship.Customer.externalRelationshipId}
            </TileField>

            <TileField label='Supplier External ID'>
                {relationship.Supplier && relationship.Supplier.externalRelationshipId}
            </TileField>            
        </Tile>
    )
}


const RelationshipPageTabs = ({
    $category
  }: {
    $category: Linked<string>;
  }) => {
    const {allCount, notConfigured, withWarnings} = React.useMemo(
        () => {
            const a = {
                allCount : globalStore.relationships.length,
                notConfigured: globalStore.relationships.filter(r => !!!r.Customer || !!!r.Supplier ).length,
                withWarnings: 0
            };
            return a;
        },
        [ globalStore.relationships ]
    );
    return (
    <Flex row>
      <TransparentTabs $value={$category}>
        <PageTab value="all" title="All" label={String(allCount)} />
        <PageTab value="notConfigured" title="With configuration ERROR" label={String(notConfigured)} />
        <PageTab value="withWarnings" title="With Warnings" label={String(withWarnings)} />
      </TransparentTabs>
      <Flex grow />
      <PrimaryButton>
            Resolve AssetQuery
      </PrimaryButton>
      <PrimaryButton
            variant="contained"
            onClick={() => Events.trigger( 'navigate', '/relationships/new')}
        >
            New Relationship
        </PrimaryButton>
    </Flex>
    );
  };
